import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronRight, History, Loader2, Paperclip } from "lucide-react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { shortDate } from "@/lib/invoice";

const sentOn = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return d.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" }) + " " + d.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
};

export default function QboHistory() {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/qbo/history").then((r) => setRows(r.data)).catch((e) => toast.error(formatError(e))); }, []);

  if (!rows) return <Loader2 className="mt-4 animate-spin text-primary" data-testid="qbo-history-loading" />;
  return (
    <div className="mt-4 border-t pt-4" data-testid="qbo-history">
      <button type="button" onClick={() => setOpen((o) => !o)} className="flex items-center gap-2 text-sm font-medium w-full hover:text-primary transition-colors" data-testid="qbo-history-toggle">
        {open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}
        <History size={15} className="text-emerald-400" />
        Sent to QuickBooks <span className="text-muted-foreground" data-testid="qbo-history-count">({rows.length})</span>
      </button>
      {!rows.length && <p className="text-xs text-muted-foreground mt-1 ml-6" data-testid="qbo-history-empty">No invoices have been sent to QuickBooks yet.</p>}
      {open && !!rows.length && (
        <div className="mt-2 divide-y max-h-72 overflow-y-auto" data-testid="qbo-history-list">
          {rows.map((r) => (
            <div key={r.id} className="py-2 flex items-center gap-3 text-sm" data-testid={`qbo-history-${r.number}`}>
              <div className="min-w-0 flex-1">
                <p className="truncate"><Link to={`/invoices/${r.id}`} className="font-mono text-primary hover:underline">{r.number}</Link> · {r.customer}</p>
                <p className="text-xs text-muted-foreground flex items-center gap-2">
                  Sent {sentOn(r.synced_at)}
                  {r.scans_attached > 0 && <span className="flex items-center gap-0.5" title="Scans attached in QuickBooks"><Paperclip size={11} /> {r.scans_attached}</span>}
                </p>
              </div>
              <span className={`shrink-0 px-2 py-0.5 rounded text-xs font-semibold ${r.paid ? "bg-emerald-600/20 text-emerald-400" : "bg-amber-500/15 text-amber-400"}`} data-testid={`qbo-history-status-${r.number}`}>
                {r.paid ? "Paid" : "Open"}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
